<app-customer-lookup (customer_selected)="selectCustomer($event)"></app-customer-lookup>
